// Variáveis Bootstrap completas por tema.
// Incluindo as versões *-rgb usadas por bg-body-tertiary e similares.
// São injetadas como inline style em cada elemento .transicao para
// sobrescrever o escopo CSS criado pelo atributo data-bs-theme
// (que impediria a herança do :root ao trocar de stylesheet).

export const THEME_ORDER = ["cyborg", "vapor", "spacelab", "journal", "minty", "morph"];

// O localStorage pode conter valores de versões antigas do site (ex.: "dark"),
// que não existem em THEME_VARS e quebrariam applyThemeVars.
export function temaValido(tema) {
  return THEME_ORDER.includes(tema) ? tema : "morph";
}

let temaAtual = temaValido(localStorage.getItem("tema")); // rastreia o tema ativo no módulo

const THEME_VARS = {
  cyborg: {
    mode: "dark",
    vars: {
      "--bs-body-bg":          "#212529",
      "--bs-body-bg-rgb":      "33, 37, 41",
      "--bs-secondary-bg":     "#222",
      "--bs-secondary-bg-rgb": "34, 34, 34",
      "--bs-tertiary-bg":      "#222426",
      "--bs-tertiary-bg-rgb":  "34, 36, 38",
      "--bs-border-color":     "#282828",
      "--bs-body-color":       "#dee2e6",
      "--bs-emphasis-color":   "#fff",
    },
  },
  vapor: {
    mode: "dark",
    vars: {
      "--bs-body-bg":          "#170229",
      "--bs-body-bg-rgb":      "23, 2, 41",
      "--bs-secondary-bg":     "#343a40",
      "--bs-secondary-bg-rgb": "52, 58, 64",
      "--bs-tertiary-bg":      "#261e35",
      "--bs-tertiary-bg-rgb":  "38, 30, 53",
      "--bs-border-color":     "#495057",
      "--bs-body-color":       "#dee2e6",
      "--bs-emphasis-color":   "#fff",
    },
  },
  spacelab: {
    mode: "dark",
    vars: {
      "--bs-body-bg":          "#2d2d2d",
      "--bs-body-bg-rgb":      "45, 45, 45",
      "--bs-secondary-bg":     "#333",
      "--bs-secondary-bg-rgb": "51, 51, 51",
      "--bs-tertiary-bg":      "#303030",
      "--bs-tertiary-bg-rgb":  "48, 48, 48",
      "--bs-border-color":     "#495057",
      "--bs-body-color":       "#dee2e6",
      "--bs-emphasis-color":   "#fff",
    },
  },
  journal: {
    mode: "light",
    vars: {
      "--bs-body-bg":          "#fff",
      "--bs-body-bg-rgb":      "255, 255, 255",
      "--bs-secondary-bg":     "#eee",
      "--bs-secondary-bg-rgb": "238, 238, 238",
      "--bs-tertiary-bg":      "#f8f9fa",
      "--bs-tertiary-bg-rgb":  "248, 249, 250",
      "--bs-border-color":     "#dee2e6",
      "--bs-body-color":       "#222",
      "--bs-emphasis-color":   "#000",
    },
  },
  minty: {
    mode: "dark",
    vars: {
      "--bs-body-bg":          "#212529",
      "--bs-body-bg-rgb":      "33, 37, 41",
      "--bs-secondary-bg":     "#343a40",
      "--bs-secondary-bg-rgb": "52, 58, 64",
      "--bs-tertiary-bg":      "#2b3035",
      "--bs-tertiary-bg-rgb":  "43, 48, 53",
      "--bs-border-color":     "#5a5a5a",
      "--bs-body-color":       "#eceeef",
      "--bs-emphasis-color":   "#fff",
    },
  },
  morph: {
    mode: "dark",
    vars: {
      "--bs-body-bg":          "#212529",
      "--bs-body-bg-rgb":      "33, 37, 41",
      "--bs-secondary-bg":     "#444b40",
      "--bs-secondary-bg-rgb": "68, 75, 64",
      "--bs-tertiary-bg":      "#333835",
      "--bs-tertiary-bg-rgb":  "51, 56, 53",
      "--bs-border-color":     "#7b8ab8",
      "--bs-body-color":       "#dee2e6",
      "--bs-emphasis-color":   "#fff",
    },
  },
};

function applyThemeVars(tema, elements) {
  const { mode, vars } = THEME_VARS[tema];
  for (let i = 0; i < elements.length; i++) {
    elements[i].setAttribute("data-bs-theme", mode);
    for (const [prop, value] of Object.entries(vars)) {
      elements[i].style.setProperty(prop, value);
    }
  }
}

function trocaTema(tema) {
  const elements = document.getElementsByClassName("transicao");

  // 1. adiciona animação e registra remoção precisa via animationend
  const arr = Array.from(elements);
  for (const el of arr) {
    el.classList.add("theme-swap-transition");
    el.addEventListener("animationend", () => {
      el.classList.remove("theme-swap-transition");
    }, { once: true });
  }

  // 2. atualiza o tema ativo e persiste
  temaAtual = tema;
  localStorage.setItem("tema", tema);

  // 3. troca stylesheet: habilita apenas o tema ativo
  THEME_ORDER.forEach(t => {
    const el = document.getElementById("theme-" + t);
    if (el) el.disabled = (t !== temaAtual);
  });

  // 4. injeta vars e atualiza data-bs-theme em cada elemento .transicao.
  //    Elementos com data-bs-theme têm escopo CSS próprio que ignora
  //    herança do :root — a única forma de sobrescrever é via inline style.
  applyThemeVars(temaAtual, elements);
}

// Injeta as variáveis do tema atual em todos os elementos .transicao.
// Deve ser chamada no mount inicial e sempre que a rota mudar, pois novos
// elementos .transicao (ex: guias) só existem no DOM após a navegação.
function initTema() {
  const elements = document.getElementsByClassName("transicao");
  applyThemeVars(temaAtual, elements);
}

export { initTema };
export default trocaTema;
